export const VARIABLE_DATA_TYPES = {
  string: 'string',
  number: 'number',
  boolean: 'boolean',
  email: 'email',
  date: 'date',
  datetime: 'datetime',
  phone_number: 'phone_number',
  uuid: 'uuid',
  employee: 'employee',
  entity: 'entity',
} as const;

export type VariableDataType = keyof typeof VARIABLE_DATA_TYPES;
